import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { AuthService } from './services/auth.service';
import { FcmService } from './services/fcm.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(),
    provideAppInitializer(() => {
      const auth = inject(AuthService);

      // On app bootstrap (first load or a full page refresh), silently renew
      // the session from the stored refresh token if the access token is
      // missing or expired, so the user isn't bounced to /login unnecessarily.
      if (auth.isAuthenticated() || !auth.hasValidRefreshToken()) {
        if (auth.isAuthenticated() && auth.accessToken) {
          inject(FcmService).register(auth.accessToken);
        }
        return Promise.resolve();
      }

      return firstValueFrom(auth.refreshAccessToken()).then(() => undefined);
    }),
  ],
};
